module.exports = __webpack_public_path__ + "img/arrow_down.2a4abe03.svg";